import { MagnifyingGlass, X } from '@phosphor-icons/react';

import React from 'react';

interface FormProps {
  className?: string;
  formRef: React.RefObject<HTMLFormElement>;
  inputRef: React.RefObject<HTMLInputElement>;
  onFocus?: () => void;
  onBlur?: () => void;
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
  initialValue: string;
}

export const SearchForm: React.FC<FormProps> = ({
  formRef,
  inputRef,
  className,
  onInput,
  initialValue = '',
}) => {
  const [text, setText] = React.useState(initialValue);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
    onInput && onInput(e);
  };

  const clearInput = () => {
    // @ts-ignore
    inputRef.current.value = '';
    // @ts-ignore
    inputRef.current.focus();
    setText('');
    onInput && onInput({ target: inputRef.current } as any);
  };
  return (
    <form
      ref={formRef}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevent form submission
        }
      }}
      className={`flex items-center border-0 border-b-2 border-gray-400 shadow-none focus-within:bg-white focus:border-blue-500 focus:outline-none ${className}`}
    >
      <div className='relative w-full'>
        {/* Input with rounded bottom corners */}
        <input
          className='h-[40px] w-full appearance-none rounded-b-lg border-none bg-transparent !bg-none p-0 pb-3 font-sans text-2xl text-charcoal placeholder:text-[#ccc] focus:outline-none sm:h-[60px] sm:pb-3 sm:text-5xl'
          ref={inputRef}
          placeholder='Search iK Hustle'
          onInput={handleChange}
          defaultValue={initialValue}
          maxLength={500}
        />
      </div>
      {!text ? (
        <button
          className='h-full px-3 font-bold [&_path]:stroke-charcoal-500 [&_stroke]:text-charcoal-500'
          type='submit'
          title='Submit'
          onClick={(e) => {
            e.preventDefault();
            // @ts-ignore
            inputRef.current.focus();
            handleChange({ target: inputRef.current } as any);
          }}
        >
          <MagnifyingGlass weight='bold' size={20} />
        </button>
      ) : (
        <button
          className='h-full px-3 font-bold [&_path]:stroke-charcoal-500 [&_stroke]:text-charcoal-500'
          type='button'
          title='Clear'
          onClick={(e) => {
            e.preventDefault();
            clearInput();
          }}
        >
          <X weight='bold' size={20} />
        </button>
      )}
    </form>
  );
};
